module.exports = __webpack_public_path__ + "kudos_47.svg?2b432d4b7a17614f0fd64b5aa7452b20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_47.svg
// module id = 147
// module chunks = 0